import Vue from 'vue'
import Router from 'vue-router'
import Dshbord from '@/components/templates/Dshbord/DshbordCntnt'
import Login from '@/components/templates/LoginSnb'
import KiykskSntk from '@/components/templates/KiykskSntk'
import Master from '@/components/templates/Master'
import UsrPassChange from '@/components/modules/UsrPassChange'

import UsrMstrKnr from '@/components/templates/UsrMstr/UsrMstrKnr'
import UsrMstrSnkTurkPrnt from '@/components/templates/UsrMstr/UsrMstrSnkTurkPrnt'
import UsrMstrSnkTurk from '@/components/templates/UsrMstr/UsrMstrSnkTurk'
import UsrMstrJuhuShusi from '@/components/templates/UsrMstr/UsrMstrJuhuShusi'

import KkiMstrKnr from '@/components/templates/KkiMstr/KkiMstrKnr'
import KkiMstrSnkTurkPrnt from '@/components/templates/KkiMstr/KkiMstrSnkTurkPrnt'
import KkiMstrSnkTurk from '@/components/templates/KkiMstr/KkiMstrSnkTurk'
import KkiMstrJuhuShusi from '@/components/templates/KkiMstr/KkiMstrJuhuShusi'

import KshMstrKnr from '@/components/templates/KshMstr/KshMstrKnr'
import KshMstrSnkTurkPrnt from '@/components/templates/KshMstr/KshMstrSnkTurkPrnt'
import KshMstrSnkTurk from '@/components/templates/KshMstr/KshMstrSnkTurk'
import KshMstrJuhuShusi from '@/components/templates/KshMstr/KshMstrJuhuShusi'

import KiykskMstrKnr from '@/components/templates/KiykskMstr/KiykskMstrKnr'
import KiykskMstrSnkTurkPrnt from '@/components/templates/KiykskMstr/KiykskMstrSnkTurkPrnt'
import KiykskMstrSnkTurk from '@/components/templates/KiykskMstr/KiykskMstrSnkTurk'
import KiykskMstrJuhuShusi from '@/components/templates/KiykskMstr/KiykskMstrJuhuShusi'

import PrtsMstrKnr from '@/components/templates/PrtsMstr/PrtsMstrKnr'
import PrtsMstrSnkTurkPrnt from '@/components/templates/PrtsMstr/PrtsMstrSnkTurkPrnt'
import PrtsMstrSnkTurk from '@/components/templates/PrtsMstr/PrtsMstrSnkTurk'
import PrtsMstrJuhuShusi from '@/components/templates/PrtsMstr/PrtsMstrJuhuShusi'

import HshTnknMstrKnr from '@/components/templates/HshTnknMstr/HshTnknMstrKnr'
import HshTnknMstrSnkTurkPrnt from '@/components/templates/HshTnknMstr/HshTnknMstrSnkTurkPrnt'
import HshTnknMstrSnkTurk from '@/components/templates/HshTnknMstr/HshTnknMstrSnkTurk'
import HshTnknMstrJuhuShusi from '@/components/templates/HshTnknMstr/HshTnknMstrJuhuShusi'

import EvntMstrKnr from '@/components/templates/EvntMstr/EvntMstrKnr'
import EvntMstrSnkTurkPrnt from '@/components/templates/EvntMstr/EvntMstrSnkTurkPrnt'
import EvntMstrSnkTurk from '@/components/templates/EvntMstr/EvntMstrSnkTurk'
import EvntMstrJuhuShusi from '@/components/templates/EvntMstr/EvntMstrJuhuShusi'

Vue.use(Router)

export default new Router({
  mode: 'history', // enable history mode
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/Dshbord/Dshbord',
      name: 'Dshbord',
      component: Dshbord,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      path: '/KiykskSntk',
      name: 'KiykskSntk',
      component: KiykskSntk,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    // 初期画面
    {
      path: '/initial',
      name: 'initial',
      component: Master,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    // パスワード変更画面
    {
      path: '/UsrPassChange',
      name: 'UsrPassChange',
      component: UsrPassChange,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    // user Master
    {
      // 初期リスト画面
      path: '/UsrMstr/UsrMstrKnr',
      name: 'UsrMstrKnr',
      component: UsrMstrKnr,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      // 新規登録
      path: '/UsrMstr/UsrMstrSnkTurk',
      component: UsrMstrSnkTurkPrnt,
      children: [
        {
          // 新規登録画面
          path: '/UsrMstr/UsrMstrSnkTurk',
          name: 'UsrMstrKnrTurk',
          component: UsrMstrSnkTurk,
          meta: {
            title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
          }
        }
      ]
    },
    {
      // 詳細画面
      path: '/UsrMstr/UsrMstrJuhuShusi',
      name: 'UsrMstrJuhuShusi',
      props: true,
      component: UsrMstrJuhuShusi
    },

    // kki Master
    {
      // 初期リスト画面
      path: '/KkiMstr/KkiMstrKnr',
      name: 'KkiMstrKnr',
      component: KkiMstrKnr,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      // 新規登録
      path: '/KkiMstr/KkiMstrSnkTurk',
      component: KkiMstrSnkTurkPrnt,
      children: [
        {
          // 新規登録画面
          path: '/KkiMstr/KkiMstrSnkTurk',
          name: 'KkiMstrKnrTurk',
          component: KkiMstrSnkTurk,
          meta: {
            title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
          }
        }
      ]
    },
    {
      // 詳細画面
      path: '/KkiMstr/KkiMstrJuhuShusi',
      name: 'KkiMstrJuhuShusi',
      component: KkiMstrJuhuShusi
    },

    // keiyakusaki master
    {
      // 初期リスト画面
      path: '/KiykskMstr/KiykskMstrKnr',
      name: 'KiykskMstrKnr',
      component: KiykskMstrKnr,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      // 新規登録
      path: '/KiykskMstr/KiykskMstrSnkTurk',
      component: KiykskMstrSnkTurkPrnt,
      children: [
        {
          // 新規登録画面
          path: '/KiykskMstr/KiykskMstrSnkTurk',
          name: 'KiykskMstrKnrTurk',
          component: KiykskMstrSnkTurk,
          meta: {
            title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
          }
        }
      ]
    },
    {
      // 詳細画面
      path: '/KiykskMstr/KiykskMstrJuhuShusi',
      name: 'KiykskMstrJuhuShusi',
      component: KiykskMstrJuhuShusi
    },

    // kishu Master
    {
      // 初期リスト画面
      path: '/KshMstr/KshMstrKnr',
      name: 'KshMstrKnr',
      component: KshMstrKnr,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      // 新規登録
      path: '/KshMstr/KshMstrSnkTurk',
      component: KshMstrSnkTurkPrnt,
      children: [
        {
          // 新規登録画面
          path: '/KshMstr/KshMstrSnkTurk',
          name: 'KshMstrKnrTurk',
          component: KshMstrSnkTurk,
          meta: {
            title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
          }
        }
      ]
    },
    {
      // 詳細画面
      path: '/KshMstr/KshMstrJuhuShusi',
      name: 'KshMstrJuhuShusi',
      component: KshMstrJuhuShusi
    },

    // parts Master
    {
      // 初期リスト画面
      path: '/PrtsMstr/PrtsMstrKnr',
      name: 'PrtsMstrKnr',
      component: PrtsMstrKnr,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      // 新規登録
      path: '/PrtsMstr/PrtsMstrSnkTurk',
      component: PrtsMstrSnkTurkPrnt,
      children: [
        {
          // 新規登録画面
          path: '/PrtsMstr/PrtsMstrSnkTurk',
          name: 'PrtsMstrKnrTurk',
          component: PrtsMstrSnkTurk,
          meta: {
            title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
          }
        }
      ]
    },
    {
      // 詳細画面
      path: '/PrtsMstr/PrtsMstrJuhuShusi',
      name: 'PrtsMstrJuhuShusi',
      component: PrtsMstrJuhuShusi
    },

    // hoshu tenken Master
    {
      // 初期リスト画面
      path: '/HshTnknMstr/HshTnknMstrKnr',
      name: 'HshTnknMstrKnr',
      component: HshTnknMstrKnr,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      // 新規登録
      path: '/HshTnknMstr/HshTnknMstrSnkTurk',
      component: HshTnknMstrSnkTurkPrnt,
      children: [
        {
          // 新規登録画面
          path: '/HshTnknMstr/HshTnknMstrSnkTurk',
          name: 'HshTnknMstrKnrTurk',
          component: HshTnknMstrSnkTurk,
          meta: {
            title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
          }
        }
      ]
    },
    {
      // 詳細画面
      path: '/HshTnknMstr/HshTnknMstrJuhuShusi',
      name: 'HshTnknMstrJuhuShusi',
      component: HshTnknMstrJuhuShusi
    },

    // event Master
    {
      // 初期リスト画面
      path: '/EvntMstr/EvntMstrKnr',
      name: 'EvntMstrKnr',
      component: EvntMstrKnr,
      meta: {
        title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
      }
    },
    {
      // 新規登録
      path: '/EvntMstr/EvntMstrSnkTurk',
      component: EvntMstrSnkTurkPrnt,
      children: [
        {
          // 新規登録画面
          path: '/EvntMstr/EvntMstrSnkTurk',
          name: 'EvntMstrKnrTurk',
          component: EvntMstrSnkTurk,
          meta: {
            title: 'NAVINECT Insight for EP-PAK', description: 'NAVINECT Insight for EP-PAK'
          }
        }
      ]
    },
    {
      // 詳細画面
      path: '/EvntMstr/EvntMstrJuhuShusi',
      name: 'EvntMstrJuhuShusi',
      component: EvntMstrJuhuShusi
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js